var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8457_906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.39334 32.2735C7.29557 30.1757 5.86698 27.503 5.28821 24.5933C4.70945 21.6836 5.00651 18.6676 6.14183 15.9267C7.27715 13.1858 9.19974 10.8431 11.6665 9.19494C14.1332 7.54672 17.0333 6.66699 20 6.66699C22.9667 6.66699 25.8668 7.54672 28.3335 9.19494C30.8003 10.8431 32.7229 13.1858 33.8582 15.9267C34.9935 18.6676 35.2906 21.6836 34.7118 24.5933C34.133 27.503 32.7044 30.1757 30.6067 32.2735",
    stroke: "#BF4036",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 15L20 21.6667",
    stroke: "#BF4036",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8457_906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter);
export default __webpack_public_path__ + "static/media/meter.ea4e90f144a90ffc544ea1f78defb8fa.svg";
export { ForwardRef as ReactComponent };